import { render } from "./switchFontSize.vue?vue&type=template&id=6a06db72&scoped=true"
import script from "./switchFontSize.vue?vue&type=script&lang=js"
export * from "./switchFontSize.vue?vue&type=script&lang=js"

import "./switchFontSize.vue?vue&type=style&index=0&id=6a06db72&scoped=true&lang=less"
import "./switchFontSize.vue?vue&type=style&index=1&id=6a06db72&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a06db72"]])

export default __exports__